var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 12,
    viewBox: "0 0 4 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00005 7.19999C2.66279 7.19999 3.20005 6.66273 3.20005 5.99999C3.20005 5.33725 2.66279 4.79999 2.00005 4.79999C1.33731 4.79999 0.800049 5.33725 0.800049 5.99999C0.800049 6.66273 1.33731 7.19999 2.00005 7.19999Z",
    fill: "#33894E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00005 2.99998C2.66279 2.99998 3.20005 2.46272 3.20005 1.79998C3.20005 1.13723 2.66279 0.599976 2.00005 0.599976C1.33731 0.599976 0.800049 1.13723 0.800049 1.79998C0.800049 2.46272 1.33731 2.99998 2.00005 2.99998Z",
    fill: "#33894E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00005 11.4C2.66279 11.4 3.20005 10.8627 3.20005 10.2C3.20005 9.53726 2.66279 9 2.00005 9C1.33731 9 0.800049 9.53726 0.800049 10.2C0.800049 10.8627 1.33731 11.4 2.00005 11.4Z",
    fill: "#33894E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/ThreeDots.9f2b6d21507584b0b5154278d36c1771.svg";
export { ForwardRef as ReactComponent };